export default __webpack_public_path__ + "/dist/images/logo11.f99847783d7a0c016a8d118a8e917a43.jpg";